import React from "react";

/*
 * MoneyField — comma-formatted number input
 * Shows "5,000,000" on blur, raw "5000000" while typing
 */
export function MF({ style, value, onChange, placeholder, readOnly, className }) {
  const [focused, setFocused] = React.useState(false);
  const fmt = (v) => {
    if (v === "" || v == null) return "";
    const n = parseFloat(String(v).replace(/,/g, ""));
    if (isNaN(n)) return String(v);
    const parts = String(v).split(".");
    const decs = parts.length > 1 ? Math.min(parts[1].length, 4) : 0;
    return n.toLocaleString("en-US", { minimumFractionDigits: decs, maximumFractionDigits: 4 });
  };
  return (
    <input type="text" inputMode="decimal" style={style} className={className} readOnly={readOnly}
      value={focused ? (value ?? "") : fmt(value)}
      onFocus={() => setFocused(true)} onBlur={() => setFocused(false)}
      onChange={e => onChange(e.target.value.replace(/[^0-9.\-]/g, ""))}
      placeholder={placeholder || "0"} />
  );
}

/*
 * PctField — percentage input with % suffix
 * Type 5 → shows "5 %" → means 5%
 */
export function PF({ style, value, onChange, placeholder, width, className }) {
  const w = width || "100%";
  return (
    <div style={{ position: "relative", width: w, display: "inline-block" }}>
      <input type="text" inputMode="decimal" className={className}
        style={{ ...(style || {}), paddingRight: 22, width: "100%", boxSizing: "border-box" }}
        value={value ?? ""} onChange={e => onChange(e.target.value.replace(/[^0-9.\-]/g, ""))}
        placeholder={placeholder || "0"} />
      <span style={{ position: "absolute", right: 8, top: "50%", transform: "translateY(-50%)",
        color: "#94a3b8", fontSize: 12, pointerEvents: "none" }}>%</span>
    </div>
  );
}
